import React from 'react';
import './Error.css';

function Error(props) {
    return (
        <div className="error">
            <p>404</p>
        </div>
    );
}

export default Error;